"use client";

import RouteErrorPanel from "@/app/components/errors/RouteErrorPanel";

export default function RouteError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <RouteErrorPanel error={error} reset={reset} source="route-error-boundary" />;
}
